import React from 'react';
import { MarkupRender, Modal } from '@nutastic/nutastic-react-app';

// eslint-disable-next-line react/prop-types
const StoryModal = ({ isOpen, onClose, content, title }) => {
    return <Modal show={isOpen} onClose={onClose} title={title}>
        <MarkupRender content={content} tagName="div" className="story-content" />
    </Modal>;
};

export default StoryModal;
